import { render, staticRenderFns } from "./Hints.vue?vue&type=template&id=31f2bbc4&scoped=true&"
import script from "./Hints.vue?vue&type=script&lang=js&"
export * from "./Hints.vue?vue&type=script&lang=js&"
import style0 from "./Hints.vue?vue&type=style&index=0&id=31f2bbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f2bbc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
